import { ApplicationInsights } from "@microsoft/applicationinsights-web";

let instance = null;

export function initAppInsights(options) {
    instance = new ApplicationInsights(options);
    instance.loadAppInsights();
    return instance;
}

export function getAppInsights() {
    return instance;
}